export const DEFAULT_OVERSCAN = 6;

/**
 * The grid only needs two sticky layers: the header row sits above the scrolling
 * body, and each pinned left cell sits above the columns within its own row.
 */
export const GRID_Z_INDEX = ({
  pinnedCell: 1,
  headerRow: 2
} as const);
export const VIRTUAL_AXIS = ({
  row: 'row',
  column: 'column'
} as const);
export const SCROLL_ALIGN = ({
  auto: 'auto',
  start: 'start',
  center: 'center',
  end: 'end'
} as const);
export const SCROLL_BEHAVIOR = ({
  // Instant jump — the only safe option while an element is being dragged to follow the
  // pointer, since smooth would let the viewport lag behind the tracked element.
  auto: 'auto',
  // Eased glide — for discrete, non-interactive jumps (e.g. bringing a selection into view).
  smooth: 'smooth'
} as const);